import React from 'react';
import {
    Button,
    Menu,
    MenuTrigger,
    MenuSeparator,
    MenuContent,
    MenuRadioGroup,
    MenuRadioItem,
} from '@cad-arc';
import { sortingConfig, SortingParameterName } from './sorting-config';
import { SortDirection } from '../../common/sorting/types';

export function SortMenu(props: {
    sortDirection: SortDirection;
    sortingParam: SortingParameterName;
    onChangeSortDirection: (sortOrder: SortDirection) => void;
    onChangeSortingParam: (sortingParam: SortingParameterName) => void;
}): React.ReactElement {
    return (
        <Menu>
            <MenuTrigger asChild>
                <Button size="sm" variant="outline" trailingVisual="TriangleDown" tabIndex={-1}>
                    Sort: {sortingConfig[props.sortingParam].display}
                </Button>
            </MenuTrigger>
            <MenuContent>
                <MenuRadioGroup
                    title="Sort By"
                    onValueChange={(value) =>
                        props.onChangeSortingParam(value as SortingParameterName)
                    }
                    value={props.sortingParam}
                >
                    {Object.values(sortingConfig).map((param) => {
                        return (
                            <MenuRadioItem key={param.name} value={param.name}>
                                {param.display}
                            </MenuRadioItem>
                        );
                    })}
                </MenuRadioGroup>
                <MenuSeparator />
                <MenuRadioGroup
                    title="Direction"
                    onValueChange={(value) => props.onChangeSortDirection(value as SortDirection)}
                    value={props.sortDirection}
                >
                    <MenuRadioItem value="asc" trailingVisual="ArrowDown">
                        A-Z
                    </MenuRadioItem>
                    <MenuRadioItem value="desc" trailingVisual="ArrowUp">
                        Z-A
                    </MenuRadioItem>
                </MenuRadioGroup>
            </MenuContent>
        </Menu>
    );
}
